// src/components/Layout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Users } from 'lucide-react';
import JourniLogoImg from '../assets/Journi_Logo.png';

export default function Layout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-2 cursor-pointer">
              <img src={JourniLogoImg} alt="Journi" className="w-9 h-9 object-contain" />
              <h1 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                Journi
              </h1>
            </div>
            <div className="flex items-center gap-2">
<button 
                onClick={() => navigate('/profile')}
                className="p-2 hover:bg-gray-100 rounded-lg">
                <Users className="w-5 h-5 text-gray-600" />
              </button>
              <button 
                onClick={() => {
                  localStorage.removeItem('token');
                  navigate('/');
                }}
                className="p-2 hover:bg-gray-100 rounded-lg">
                <LogOut className="w-5 h-5 text-gray-600" />
              </button>
              <div className="w-9 h-9 bg-emerald-500 rounded-full flex items-center justify-center text-white text-sm font-semibold">
                AK
              </div>
            </div>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}